export default {
  year: 2019,
  edition: "제 15회",
  date: "2019년 11월 22일 금요일",
  time: "오후 7시 ~ 10시",
  location: "다산관 D104/D105",
  links: {
    problems: {
      PDF: {
        Master: "/downloads/spc/2019/master.pdf",
        Champion: "/downloads/spc/2019/champion.pdf",
      },
      BOJ: "https://www.acmicpc.net/category/detail/2129",
    },
    solutions: {
      PDF: "/downloads/spc/2019/solutions.pdf",
    },
  },
  authors: ["박건", "박수현", "이준석", "손정연", "윤기영", "정진욱"],
  contests: [
    {
      title: "SPC 2019 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "3", "이지훈"],
        ["2", "3", "윤성호"],
        ["3", "2", "김동민"],
        ["4", "2", "김준서"],
        ["5", "2", "강민석"],
        ["6", "2", "이길원"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/scoreboard/487"]],
    },
    {
      title: "SPC 2019 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "5", "이기현"],
        ["2", "4", "이윤제"],
        ["3", "4", "이동승"],
        ["4", "4", "임지환"],
        ["5", "4", "이용욱"],
        ["6", "4", "장지훈"],
        ["7", "4", "황기덕"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/scoreboard/488"]],
    },
  ],
};
